import React, { Component } from 'react'
import { FormLabel, FormControl, FormGroup } from 'react-bootstrap'
import SelectFieldFormGroup from '../common/form/select_field_form_group'
import moment from 'moment'
import TextFieldFormGroup from '../common/form/text_field_form_group'

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]
const genders = ['male', 'female', 'unknown', 'other'].sort().map((i) => ({ gender: i.toUpperCase() }))

const collectDate = (month, day, year) => new Date(year, month, day)

const validationStateError = 'error'
const validationStateSuccess = 'success'

class IdentityInformationStep extends Component {
  state = {
    first_name: '',
    middle_name: '',
    last_name: '',
    alias: '',
    gender: '',
    birth_date: '',
    selected_country_code: '',
    month: '',
    day: '',
    year: '',
    currentYear: new Date().getFullYear(),
    bod: '',
  }

  firstNameValidationState = () => {
    const { state } = this
    if (state.first_name && state.last_name) {
      return validationStateSuccess
    } else if (!state.first_name && !state.last_name) {
      return validationStateError
    } else if (state.first_name && !state.last_name) {
      return validationStateSuccess
    } else if (!state.first_name && state.last_name) {
      return null
    }
    return null
  }

  lastNameValidationState = () => {
    const { state } = this
    if (state.first_name && state.last_name) {
      return validationStateSuccess
    } else if (!state.first_name && !state.last_name) {
      return validationStateError
    } else if (!state.first_name && state.last_name) {
      return validationStateSuccess
    } else if (state.first_name && !state.last_name) {
      return null
    }
    return null
  }

  dobValidationState = () => {
    const isValid = this.isValidDate()
    if (isValid) {
      return validationStateSuccess
    } else {
      return validationStateError
    }
  }

  handleYearChange = ({ target }) =>
    this.setState({ year: target.value }, () => this.setDate(target.value, this.state.day, this.state.month))

  handleDayChange = ({ target }) =>
    this.setState({ day: target.value }, () => this.setDate(this.state.year, target.value, this.state.month))

  handleMonthChange = ({ target }) =>
    this.setState({ month: target.value }, () => this.setDate(this.state.year, this.state.day, target.value))

  isValidDate = () => {
    let y, m, d
    m = (months.indexOf(this.state.month) + 1).toString()
    if (m.length === 1) {
      m = `0${m}`
    }
    d = this.state.day.toString()
    if (d.length === 1) {
      d = `0${d}`
    }
    y = this.state.year
    const birthYearIsValid = parseInt(y) >= 1919 && parseInt(y) <= 2009
    const isValid = moment(`${y}/${m}/${d}`, 'YYYY/MM/DD', true).isValid() && birthYearIsValid
    return isValid
  }

  setDate = (year, day, month) => {
    if (month && day && year) {
      const date = moment(collectDate(months.indexOf(month), day, year)).format('YYYY-MM-DD')
      this.setState({ birth_date: date }, () =>
        this.props.handleChange('identityInformationStep', 'transactionIdentity', this.getValues(), this.isValidForm())
      )
    } else {
      this.props.handleChange('identityInformationStep', 'transactionIdentity', null, this.isValidForm())
    }
  }

  handleInputChange = (e) => {
    const updatedValues = { ...this.getValues(), [e.target.name]: e.target.value }
    this.setState({ [e.target.name]: e.target.value }, () =>
      this.props.handleChange('identityInformationStep', 'transactionIdentity', updatedValues, this.isValidForm())
    )
  }

  isValidForm = () => {
    return (
      this.firstNameValidationState() !== validationStateError &&
      this.lastNameValidationState() !== validationStateError &&
      this.isValidDate()
    )
  }

  getValues = () => ({
    first_name: this.state.first_name,
    middle_name: this.state.middle_name,
    last_name: this.state.last_name,
    alias: this.state.alias,
    gender: this.state.gender,
    birth_date: this.state.birth_date,
    selected_country_code: this.state.selected_country_code,
  })

  componentDidMount() {
    const { data } = this.props
    const bod = data.birth_date ? moment(data.birth_date) : null
    const month = bod ? bod.format('MMMM') : 'January'
    const day = bod ? bod.format('DD') : ''
    const year = bod ? bod.format('YYYY') : ''
    const currentYear = new Date().getFullYear()
    this.setState(
      {
        first_name: data.first_name || '',
        middle_name: data.middle_name || '',
        last_name: data.last_name || '',
        alias: data.alias || '',
        gender: data.gender || '',
        birth_date: data.birth_date || null,
        selected_country_code: data.selected_country_code,
        month,
        year,
        day,
        currentYear,
      },
      () => {
        this.props.handleChange('identityInformationStep', 'transactionIdentity', this.getValues(), this.isValidForm())
      }
    )
  }

  render() {
    const {
      handleDayChange,
      dobValidationState,
      handleMonthChange,
      isValidDate,
      handleInputChange,
      firstNameValidationState,
      lastNameValidationState,
      handleYearChange,
      state,
    } = this
    const { month, year, day, currentYear } = state

    return (
      <div className='identity-information-step'>
        <h2 className='text-center'>Identity Information</h2>
        <div className='row'>
          <div className='col-md-4'>
            <TextFieldFormGroup
              help='Required'
              autoFocus
              placeholder={'First Name'}
              value={state.first_name}
              name={'first_name'}
              controlId='first_name'
              controlLabel='First Name'
              validationState={firstNameValidationState()}
              handleFieldChange={handleInputChange}
            />
          </div>
          <div className='col-md-4'>
            <TextFieldFormGroup
              placeholder={'Middle Name'}
              value={state.middle_name}
              controlId='middle_name'
              name='middle_name'
              controlLabel='Middle Name'
              handleFieldChange={handleInputChange}
            />
          </div>
          <div className='col-md-4'>
            <TextFieldFormGroup
              help='Required'
              placeholder={'Last Name'}
              value={state.last_name}
              controlId='last_name'
              name='last_name'
              controlLabel='Last Name'
              validationState={lastNameValidationState()}
              handleFieldChange={handleInputChange}
            />
          </div>
        </div>
        <div className='row'>
          <div className='col-md-4'>
            <TextFieldFormGroup
              placeholder={'Alias'}
              value={state.alias}
              controlId='alias'
              name='alias'
              controlLabel='Alias'
              handleFieldChange={handleInputChange}
            />
          </div>
          <div className='col-md-4'>
            <SelectFieldFormGroup
              value={state.gender.toUpperCase()}
              controlId='gender'
              controlLabel='Gender'
              data={genders}
              propName={'gender'}
              name={'gender'}
              handleFieldChange={handleInputChange}
            />
          </div>
        </div>
        <div className='row'>
          <div className='col-md-4'>
            <FormGroup controlId={'dob_month'}>
              <FormLabel>Month</FormLabel>
              <FormControl
                name={'dob_month'}
                as='select'
                isInvalid={!isValidDate()}
                className={'form-control'}
                value={month}
                placeholder='select'
                onChange={handleMonthChange}
              >
                {months.map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </FormControl>
              <FormControl.Feedback />
            </FormGroup>
          </div>

          <div className='col-md-4'>
            <FormGroup controlId={'day'}>
              <FormLabel>{'DOB Day'}</FormLabel>
              <FormControl
                placeholder={'Day'}
                type='number'
                value={day}
                onChange={handleDayChange}
                name={'day'}
                max={31}
                min={1}
                isInvalid={dobValidationState() === 'error'}
              />
            </FormGroup>
          </div>

          <div className='col-md-4'>
            <FormGroup controlId={'year'}>
              <FormLabel>{'DOB Year'}</FormLabel>
              <FormControl
                placeholder={'Year'}
                type='number'
                value={year}
                onChange={handleYearChange}
                name={'year'}
                disabled={false}
                max={currentYear}
                min={1920}
                isInvalid={dobValidationState() === 'error'}
              />
            </FormGroup>
          </div>
        </div>
      </div>
    )
  }
}

export default IdentityInformationStep
